import {hostGenerator} from '@afreecatv/domains';

export const HOST: any = {
  ...hostGenerator({
    environment: process.env.APP_ENV as any,
    currentProtocol: document.location.protocol as any,
    hostname: document.location.hostname as any,
  }),
};

export const VEDITOR_AFREECATV_DOMAIN = HOST.VEDITOR_AFREECATV;
export const WWW_AFREECATV_DOMAIN = HOST.WWW_AFREECATV;
export const VOD_AFREECATV_DOMAIN = HOST.VOD_AFREECATV;
export const M_VOD_AFREECATV_DOMAIN = HOST.M_AFREECATV + '/#/video';
export const STBBS_AFREECATV_DOMAIN = HOST.STBBS_AFREECATV;
export const LIVE_AFREECATV_DOMAIN = HOST.LIVE_AFREECATV;
export const VOD_ARCHIVE_KR_CDN_Z01_AFREECATV_DOMAIN =
  HOST.VOD_ARCHIVE_KR_CDN_Z01;
export const HLS_AFREECATV_DOMAIN = HOST.HLS_AFREECATV;
export const BJ_AFREECATV_DOMAIN = BJ_AFREECATV || HOST.BJ_AFREECATV;
export const POINT_AFREECATV_DOMAIN = HOST.POINT_AFREECATV;
export const ADBALLOON_AFREECATV_DOMAIN = HOST.ADBALLOON_AFREECATV;
export const ADREVENUE_AFREECATV_DOMAIN = HOST.ADREVENUE_AFREECATV;
export const TOKEN_AFREECATV_DOMAIN = HOST.TOKEN_AFREECATV;
export const BROADSTATISTIC_AFREECATV_DOMAIN = HOST.BROADSTATISTIC_AFREECATV;
export const NOTE_AFREECATV_DOMAIN = HOST.NOTE_AFREECATV;
export const SHOP_AFREECATV_DOMAIN = HOST.SHOPFREECA_AFREECATV;
export const FFOM_AFREECATV_DOMAIN = HOST.FFOM_AFREECATV;
export const MYPOINT_AFREECATV_DOMAIN = HOST.MYPOINT_AFREECATV;
export const MYREVENUE_AFREECATV_DOMAIN = HOST.MYREVENUE_AFREECATV;
export const MY_AFREECATV_DOMAIN = HOST.MY_AFREECATV;
export const EXTENSION_AFREECATV_DOMAIN = HOST.EXTENSION_AFREECATV;
export const DASHBOARD_AFREECATV_DOMAIN = HOST.DASHBOARD_AFREECATV;
export const LOGIN_AFREECATV_DOMAIN = HOST.LOGIN_AFREECATV;
export const MEMBER_AFREECATV_DOMAIN = HOST.MEMBER_AFREECATV;
export const HELP_URL_DOMAIN = HOST.BJ_AFREECATV + '/afvodtv/post/51987760'; // 구간 편집기 사용 방법 URL
export const WEB_EDITOR_HELP_URL_DOMAIN =
  HOST.BJ_AFREECATV + '/afvodtv/post/58472424'; // 웹 편집기 사용 방법 URL

export const JAVASCRIPT_VOID = '#';

export const SCREEN_WIDTH = window.screen.availWidth; // 실제 사용 가능한 윈도우 해상도(ex. 작업표시줄 같은거 제외)

export const TRANSCODING_FLAG = -3; // 트랜스코딩 중인지

export const CHAT_MAX_LINE = 300; // 채팅 최대 갯수
export const NEXT_FILE_PREPARE_SECONDS = 5; // 다음 파일 미리 로드하는 초
export const CUT_LIMIT_DURATION = 1800; // 편집 제한 시간(seconds)
export const CUT_MIN_DURATION = 15; // 편집 최소 시간(seconds)

export const AFREECA = 'afreeca';
export const WOWZA = 'wowza';

export const CLICK_LOG_TYPE = 'vod_editor_00000001'; // 클릭 로그 편집기 타입

export const UCC_ADULT_CATEGORY = '00030000'; // 연령제한 카테고리
export const MAX_TITLE_LEN = 130; // 제목 최대 길이

export const SECTION_EDITOR_VERSION = 2; // 구간 편집기 버전

export const AUTH_NO_LIST = {
  ALL: 101,
  HIDDEN: 102,
  OPEN_FAN: 103,
  OPEN_FANCLUB: 104,
  OPEN_CLUBBJ: 105,
  OPEN_STMANAGER: 106,
  OPEN_SUBSCRIPTION: 107,
}; // auth_no 권한 상수

export const LANGUAGE_LIST = [
  {code: 'ko_KR', name: '한국어'},
  {code: 'th_TH', name: 'ไทย'},
  {code: 'en_US', name: 'English'},
  {code: 'zh_CN', name: '中文'},
  {code: 'es_ES', name: 'Español'},
  {code: 'pt_PT', name: 'Português'},
  {code: 'ja_JP', name: '日本語'},
  {code: 'de_DE', name: 'Deutsch'},
  {code: 'hi_IN', name: 'हिन्दी'},
  {code: 'id_ID', name: 'Bahasa Indonesia'},
  {code: 'ms_MY', name: 'Bahasa Melayu'},
  {code: 'ru_RU', name: 'Русский'},
  {code: 'fr_FR', name: 'Français'},
  {code: 'ar_SA', name: 'ةيبرعلايبرعلا'},
  {code: 'tl_PH', name: 'Filipino'},
  {code: 'vi_VN', name: 'Tiếng Việt'},
  {code: 'etc', name: 'Other'},
];
